<template>
    <div v-for="(item, index) in items" :key="index">
        <div class="services-landing__second-level-item" :id="item.id" @click="setActive(item)">
            <i v-if="item.children.length > 0 && active && active.url === item.url" class="icon-close"></i>
            <i v-if="item.children.length > 0 && (!active || active.url !== item.url)" class="icon-plus"></i>
            {{ item.title }}
            <span v-if="item.children.length > 0">({{ item.children.length }})</span>
            <span class="services-landing__translations" v-if="item.hasCulture">{{
                item.translationsAvailableLabel }}</span>
        </div>
        <div class="services-landing__third-level-wrapper"
            v-if="item.children.length > 0 && active && active.url === item.url">
            <ServicesThirdLevel :items="item.children" />
        </div>
        <a v-if="item.children.length > 0 && active && active.url === item.url" :href="item.url" class="button">Go to Full
            Page</a>
        <hr v-if="item.children.length > 0 && active && active.url === item.url" :href="item.url">
    </div>
</template>

<script>
import ServicesThirdLevel from "./ServicesThirdLevel.vue"

export default {
    props: ["items"],
    components: {
        ServicesThirdLevel
    },
    data() {
        return {
            active: null
        }
    },
    methods: {
        setActive: function (item) {
            if (item.children.length === 0) {
                window.location.href = item.url;
                return;
            }
            if (this.active && this.active.url === item.url) {
                this.active = null
            } else {
                this.active = item

                this.$nextTick(() => {
                    var element = document.getElementById(item.id);
                    var headerOffset = 75;
                    var elementPosition = element.getBoundingClientRect().top;
                    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                });
            }
        }
    }

}
</script>

